<template>
	<div v-if="showScroes">
		<div class="main_scroe_fadein">
			<div class="main_box">
				<div class="box">
					<div class="head">
						<img src="@/assets/images/sc_03.jpg" />
						<div>
							<p>Pearson丨PTE Academic 丨 Score Report丨Mock Test</p>
							<span>Score Report Code:1224 </span>
						</div>
					</div>
					<div class="child">
						<div class="top">
							<img src="@/assets/images/sc_07.jpg" />
							<div v-if="scroeInfo.listeningScore!=0&&scroeInfo.readingScore!=0&&scroeInfo.speakingScore!=0&&scroeInfo.writingScore!=0">
								<span>Overall Score</span>
								<p>{{scroeInfo.overallScore}}</p>
							</div>
						</div>
						<div class="scroe_info">
							<p class="title">Communicative Skills</p>
							<ul>
								<li v-if="scroeInfo.listeningScore!=0">
									<div>{{scroeInfo.listeningScore}}</div>
									<span>Listening</span>
								</li>
								<li v-if="scroeInfo.readingScore!=0">
									<div>{{scroeInfo.readingScore}}</div>
									<span>Reading</span>
								</li>
								<li v-if="scroeInfo.speakingScore!=0">
									<div>{{scroeInfo.speakingScore}}</div>
									<span>Speaking</span>
								</li>
								<li v-if="scroeInfo.writingScore!=0">
									<div>{{scroeInfo.writingScore}}</div>
									<span>Writing</span>
								</li>
							</ul>
						</div>
						<div class="bottom">
							<div class="left">
								<div class="title">Skills Breakdown</div>
								<div class="data">
									<div class="lab" v-if="scroeInfo.listeningScore!=0">
										<p>Listening</p>
										<span>{{scroeInfo.listeningScore}}</span>
										<div class="line">
											<div></div>
										</div>
									</div>
									<div class="lab" v-if="scroeInfo.readingScore!=0">
										<p>Reading</p>
										<span>{{scroeInfo.readingScore}}</span>
										<div class="line">
											<div></div>
										</div>
									</div>
									<div class="lab" v-if="scroeInfo.speakingScore!=0">
										<p>Speaking</p>
										<span>{{scroeInfo.speakingScore}}</span>
										<div class="line">
											<div></div>
										</div>
									</div>
									<div class="lab" v-if="scroeInfo.writingScore!=0">
										<p>Writing</p>
										<span>{{scroeInfo.writingScore}}</span>
										<div class="line">
											<div></div>
										</div>
									</div>
								</div>
							</div>
							<div class="right">
								<div class="title">Candidate Information</div>
								<div class="info">
									<p>user name：<span>{{scroeInfo.userName}}</span></p>
									<p>Test Date：<span>{{scroeInfo.createTime}}</span></p>
									<em>This Mock PTE Academic test wastaken at home or in an office. lt willnot be accepted at all insitutions.</em>
								</div>
							</div>
						</div>
					</div>
					<div class="button">
						<div @click="back">{{$t('done')}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'showScroe',
		props: ['scroeInfo'],
		data() {
			return {

			}
		},
		computed: {
			showScroes() {
				console.log("showScore::");
				console.log(this.scroeInfo);
				return this.$store.state.showScroe;
			}
		},
		methods: {
			back() {
				if(!this.$router){
					this.$router.push({ path: '/package_test' })
					return;
				}
				const routePath = this.$router;
				this.close()
				if(routePath.fullPath != '/package_test'){
					this.$router.push({ path: '/package_test' })
				}
				console.log(routePath)
			},
			close() {
				this.$store.commit("showScroeInfo", false);
			},
		},
	}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/showScroe.vue